import React from 'react';
import {Flex, Box} from '@chakra-ui/react';
import {useCustomer} from '../../../../hooks/api/metadata';
import {getCreditsNeededForEnrichment} from '../../../../shared/credits';
import {pluralize} from '../../../../lib/helpers';
import {useAgentFields} from '../helpers';
import {useAgentBuilderServerState} from '../AgentBuilder.state';
import {CreditCostTag} from '../../../App/CreditCostTag';
import {ensure} from '../../../../shared/util';

export const CreditsSection = () => {
  const agentId = useAgentBuilderServerState().id;
  const {primaryField} = useAgentFields(agentId);

  const customer = useCustomer();
  const numCredits = getCreditsNeededForEnrichment({
    fields: customer.fieldDefinitions,
    fieldId: ensure(primaryField).id,
    numAccounts: 1,
  });

  return (
    <Flex gap="2" alignItems="center">
      <CreditCostTag fontSize="sm" creditCost={numCredits} />
      <Box color="kgray.300">
        This agent will use{' '}
        <Box as="span" color="kgray.500" fontWeight="500">
          {pluralize(numCredits, 'credit', 'credits')}
        </Box>{' '}
        per account enriched.
      </Box>
    </Flex>
  );
};
